// any changes DISPATCH_TRACKING & LIVE_SHARE should be reflected in index.ejs & locale-detection.ejs
const DISPATCH_TRACKING = 'trace';
const LIVE_SHARE = 'tracking';
const GEOTAB_AUTH_FAIL = 'geotab-auth-fail';
const REVIEWABLE_FRAUD_TXN = 'transaction-review';
const FLEET_CARD_TERMS_OF_SERVICE = 'fleet-card-terms-of-service';
const FLEET_CARD_FEE_SCHEDULE = 'motive-card-fee-schedule';
const VERIFY_CARD_APPLICATION = 'verify-card-application';
const FLEET_CARD_GET_PERSONALIZED_ANALYSIS = 'fleet-card-get-personalized-analysis';
const SAFETY_RECAP_VIDEO = 'safety-recap-video';
const VIRTUAL_CARD_PROVISION = 'virtual-card-provision';
const CANADA_LIVENESS_CHECK = 'canada-liveness-check';
const MOTIVE_CARD_TERMS_AND_CONDITIONS = 'motive-card-terms-and-conditions';
const DRIVER_FACE_MATCH_PROFILE = 'driver-face-match-profile';

export function isPublicUrlAccess(): boolean {
  return (
    isPubliclyAccessibleURL(LIVE_SHARE) ||
    isPubliclyAccessibleURL(DISPATCH_TRACKING) ||
    isPubliclyAccessibleURL(GEOTAB_AUTH_FAIL, false) ||
    isPubliclyAccessibleURL(REVIEWABLE_FRAUD_TXN, false) ||
    isPubliclyAccessibleURL(FLEET_CARD_TERMS_OF_SERVICE, false) ||
    isPubliclyAccessibleURL(FLEET_CARD_FEE_SCHEDULE, false) ||
    isPubliclyAccessibleURL(VERIFY_CARD_APPLICATION, false) ||
    isPubliclyAccessibleURL(FLEET_CARD_GET_PERSONALIZED_ANALYSIS, false) ||
    isPubliclyAccessibleURL(SAFETY_RECAP_VIDEO, false) ||
    isPubliclyAccessibleURL(VIRTUAL_CARD_PROVISION, false) ||
    isPubliclyAccessibleURL(CANADA_LIVENESS_CHECK, false) ||
    isPubliclyAccessibleURL(MOTIVE_CARD_TERMS_AND_CONDITIONS, false) ||
    isPubliclyAccessibleURL(DRIVER_FACE_MATCH_PROFILE, false)
  );
}

function isPubliclyAccessibleURL(trackingIdentifier: string, checkSubDomain = true): boolean {
  const url = window.location.href;

  if (checkSubDomain) {
    const indexOfFirstDot = url.indexOf('.');
    // TODO: Remove following if block once url formating BE changes come in place
    if (trackingIdentifier === DISPATCH_TRACKING) {
      (window as any)['publicDispatchData'] = { token: getParameterByName('token'), iv: getParameterByName('iv')};

    }
    return url.slice(indexOfFirstDot - trackingIdentifier.length, indexOfFirstDot) === trackingIdentifier;
  } else {

    const publicRouteIdentifiers: string[] = [
      REVIEWABLE_FRAUD_TXN,
      FLEET_CARD_TERMS_OF_SERVICE,
      VERIFY_CARD_APPLICATION,
      FLEET_CARD_GET_PERSONALIZED_ANALYSIS,
      SAFETY_RECAP_VIDEO,
      CANADA_LIVENESS_CHECK,
      MOTIVE_CARD_TERMS_AND_CONDITIONS,
      DRIVER_FACE_MATCH_PROFILE,
    ];
    if (trackingIdentifier === VIRTUAL_CARD_PROVISION) {
      return checkPathContainsSegment(window.location.toString(), trackingIdentifier);
    }
    if (publicRouteIdentifiers.includes(trackingIdentifier)) {
      return checkLastPath(window.location.toString(), trackingIdentifier, true);
    }

    return checkLastPath(window.location.toString(), trackingIdentifier, false);
  }
}

export function getParameterByName(name: string, url: string = window.location.href) {
  const regex: RegExp = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results: RegExpExecArray | null = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function checkLastPath(url: string, stringToMatch: string, hasQueryParam: boolean) {
  const parsedUrl = new URL(url);
  const pathComponents = parsedUrl.href.split('/');
  const lastPathComponent = hasQueryParam ?
    pathComponents[pathComponents.length - 1].split('?')[0] :
    pathComponents[pathComponents.length - 1];
  return lastPathComponent === stringToMatch;
}

function checkPathContainsSegment(url: string, stringToMatch: string): boolean {
  const parsedUrl: URL = new URL(url);
  const pathComponents: string[] = parsedUrl.href.split('?')[0].split('/');
  return pathComponents.includes(stringToMatch);
}